'use-client';
import * as React from 'react';
import type {
  ISlideShowGalleryImperativeActions,
  ISlideShowGalleryProps,
} from '../../../SlideShowGallery.types';
import SlideShowGallery from '../../SlideShowGallery';
import skinsItemStyle from '../../../../SlideShowGalleryItem/viewer/style/SlideShowPolaroidItem.scss';
import skinsStyle from './styles/SlideShowPolaroid.scss';

const SlideShowPolaroid: React.ForwardRefRenderFunction<
  ISlideShowGalleryImperativeActions,
  Omit<ISlideShowGalleryProps, 'skin'>
> = (props, ref) => (
  <SlideShowGallery
    ref={ref}
    {...props}
    skinsItemStyle={skinsItemStyle}
    skinsStyle={skinsStyle}
  />
);

export default React.forwardRef(SlideShowPolaroid);
